import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'options-emprunteur-form',
    templateUrl: './options-emprunteur-form.component.html',
    styleUrls: ['./options-emprunteur-form.component.scss'],
    standalone: false
})
export class OptionsEmprunteurComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  productType: string;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.productType = this.subscriptionFacade.getPledge()?.productType;
    this.subscriptionFacade.initForm(this, { productType: this.productType });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
